import { useCallback } from 'react';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { transformEmployeeFormToPayload } from 'src/components/enterprise/features/Employee/utils/employee.utils';

interface UseEmployeeFormSubmitProps {
  onSubmit: (data: EmployeeFormFields) => Promise<void>;
}

export const useEmployeeFormSubmit = ({
  onSubmit,
}: UseEmployeeFormSubmitProps): {
  handleSubmit: (values: EmployeeFormFields) => Promise<void>;
} => {
  const { corpData } = useEmployeeFormContext();

  const handleSubmit = useCallback(
    async (values: EmployeeFormFields): Promise<void> => {
      const payload = transformEmployeeFormToPayload(values, corpData);
      await onSubmit(payload);
    },
    [corpData, onSubmit]
  );

  return { handleSubmit };
};
